import { siteConstants } from "../constants/siteConstants";
import { siteService } from "../../services/API/siteService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";

export const siteActions = {
  add_site_details,
  checkUserNameData,
  checkSiteNameData,
  checkUserEmail,
  getSiteList,
  getSitepaidList,
  getSiteInactiveList,
  getSiteDetailsBySiteId,
  update_site_details,
  delete_site_details,
  update_status,
  checkSiteDomainData,
  get_city_geoLocation,
  getDashobardData,
  getPaidDashobardData,
  getCustomerData,
  subDomain,
  domainList,
  deleteDomain,
  installssl,
};

function getCustomerData(formData) {
  return (dispatch) => {
    siteService.getCustomerData(formData).then(
      (responseData) => {
        dispatch(success(responseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConstants.GET_CUSTOMER_DATA_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConstants.GET_CUSTOMER_DATA_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConstants.GET_CUSTOMER_DATA_FAILURE, error };
  }
}

function getDashobardData(formData) {
  return (dispatch) => {
    siteService.getDashobardData(formData).then(
      (responseData) => {
        dispatch(success(responseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConstants.GET_DASHBOARD_DETAILS_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConstants.GET_DASHBOARD_DETAILS_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConstants.GET_DASHBOARD_DETAILS_FAILURE, error };
  }
}
function getPaidDashobardData(formData) {
  return (dispatch) => {
    siteService.getPaidDashobardData(formData).then(
      (responseData) => {
        dispatch(success(responseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConstants.GET_PAIDDASHBOARD_DETAILS_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConstants.GET_PAIDDASHBOARD_DETAILS_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConstants.GET_PAIDDASHBOARD_DETAILS_FAILURE, error };
  }
}
function add_site_details(sitepostdata) {
  return (dispatch) => {
    dispatch(request({ sitepostdata }));
    siteService.add_site_data(sitepostdata).then(
      (sitedata) => {
        dispatch(success(sitedata));
        history.push("/viewSiteList");
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(sitedata) {
    return { type: siteConstants.ADD_SITE_REQUEST, sitedata };
  }
  function success(sitedata) {
    return { type: siteConstants.ADD_SITE_SUCCESS, sitedata };
  }
  function failure(error) {
    return { type: siteConstants.ADD_SITE_FAILURE, error };
  }
}

function update_site_details(postdata) {
  return (dispatch) => {
    dispatch(request({ postdata }));
    siteService.update_site_data(postdata).then(
      (updatesite) => {
        dispatch(success(updatesite));
        history.push("/viewSiteList"); // back to view site list
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(updatesite) {
    return { type: siteConstants.UPDATE_SITE_REQUEST, updatesite };
  }
  function success(updatesite) {
    return { type: siteConstants.UPDATE_SITE_SUCCESS, updatesite };
  }
  function failure(error) {
    return { type: siteConstants.UPDATE_SITE_FAILURE, error };
  }
}

function update_status(propsData) {
  return (dispatch) => {
    dispatch(request());
    if (propsData && propsData.siteID !== "" && propsData.status !== "") {
      siteService.update_status(propsData).then(
        (updatestatus) => {
          dispatch(success(updatestatus));
          history.push("/viewSiteList"); // back to view site list
        },
        (error) => {
          dispatch(failure(error.toString()));
        }
      );
    }
  };

  function request(updatestatus) {
    return { type: siteConstants.UPDATE_SITE_STATUS_REQUEST, updatestatus };
  }
  function success(updatestatus) {
    return { type: siteConstants.UPDATE_SITE_STATUS_SUCCESS, updatestatus };
  }
  function failure(error) {
    return { type: siteConstants.UPDATE_SITE_STATUS_FAILURE, error };
  }
}

function delete_site_details(siteID) {
  return (dispatch) => {
    siteService.delete_site_data(siteID).then(
      (site) => {
        dispatch(success(site));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(site) {
    return { type: siteConstants.DELETE_SITE_REQUEST, site };
  }
  function success(site) {
    return { type: siteConstants.DELETE_SITE_SUCCESS, site };
  }
  function failure(error) {
    return { type: siteConstants.DELETE_SITE_FAILURE, error };
  }
}

function checkUserNameData(userName) {
  return (dispatch) => {
    dispatch(request({ userName }));
    siteService.check_userName(userName).then(
      (message) => {
        dispatch(success(message));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(message) {
    return { type: siteConstants.CHECK_USERNAME_REQUEST, message };
  }
  function success(message) {
    return { type: siteConstants.CHECK_USERNAME_SUCCESS, message };
  }
  function failure(error) {
    return { type: siteConstants.CHECK_USERNAME_FAILURE, error };
  }
}

function checkSiteNameData(siteName) {
  return (dispatch) => {
    dispatch(request({ siteName }));
    siteService.check_siteName(siteName).then(
      (message) => {
        dispatch(success(message));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(message) {
    return { type: siteConstants.CHECK_SITENAME_REQUEST, message };
  }
  function success(message) {
    return { type: siteConstants.CHECK_SITENAME_SUCCESS, message };
  }
  function failure(error) {
    return { type: siteConstants.CHECK_SITENAME_FAILURE, error };
  }
}

function checkUserEmail(email) {
  return (dispatch) => {
    dispatch(request({ email }));
    siteService.check_userEmail(email).then(
      (emailResponse) => {
        dispatch(success(emailResponse));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(emailResponse) {
    return { type: siteConstants.CHECK_USER_EMAIL_REQUEST, emailResponse };
  }
  function success(emailResponse) {
    return { type: siteConstants.CHECK_USER_EMAIL_SUCCESS, emailResponse };
  }
  function failure(error) {
    return { type: siteConstants.CHECK_USER_EMAIL_FAILURE, error };
  }
}

function getSiteList(page) {
  return (dispatch) => {
    siteService.get_SiteList(page).then(
      (sitelist) => {
        dispatch(success(sitelist));
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };
  function request(sitelist) {
    return { type: siteConstants.VIEW_SITELIST_REQUEST, sitelist };
  }
  function success(sitelist) {
    return { type: siteConstants.VIEW_SITELIST_SUCCESS, sitelist };
  }
  function failure(error) {
    return { type: siteConstants.VIEW_SITELIST_FAILURE, error };
  }
}
function getSitepaidList(page) {
  return (dispatch) => {
    siteService.get_SitepaidList(page).then(
      (sitelist) => {
        dispatch(success(sitelist));
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };
  function request(sitelist) {
    return { type: siteConstants.VIEW_SITEPAIDLIST_REQUEST, sitelist };
  }
  function success(sitelist) {
    return { type: siteConstants.VIEW_SITEPAIDLIST_SUCCESS, sitelist };
  }
  function failure(error) {
    return { type: siteConstants.VIEW_SITEPAIDLIST_FAILURE, error };
  }
}
function getSiteInactiveList(page) {
  return (dispatch) => {
    siteService.get_SiteInactiveList(page).then(
      (sitelist) => {
        dispatch(success(sitelist));
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };
  function request(sitelist) {
    return { type: siteConstants.VIEW_SITELIST_REQUEST, sitelist };
  }
  function success(sitelist) {
    return { type: siteConstants.VIEW_SITELIST_SUCCESS, sitelist };
  }
  function failure(error) {
    return { type: siteConstants.VIEW_SITELIST_FAILURE, error };
  }
}

function getSiteDetailsBySiteId(id) {
  return (dispatch) => {
    siteService.getSiteDetailsBySiteId(id).then(
      (sitedatabyId) => {
        dispatch(success(sitedatabyId));
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };
  function request(sitedatabyId) {
    return { type: siteConstants.VIEW_SITEDATABYID_REQUEST, sitedatabyId };
  }
  function success(sitedatabyId) {
    return { type: siteConstants.VIEW_SITEDATABYID_SUCCESS, sitedatabyId };
  }
  function failure(error) {
    return { type: siteConstants.VIEW_SITEDATABYID_FAILURE, error };
  }
}

function checkSiteDomainData(siteDomainData) {
  return (dispatch) => {
    dispatch(request({ siteDomainData }));
    siteService.check_site_domain(siteDomainData).then(
      (siteDomainProps) => {
        dispatch(success(siteDomainProps));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(siteDomainProps) {
    return { type: siteConstants.CHECK_SITEDOMAIN_REQUEST, siteDomainProps };
  }
  function success(siteDomainProps) {
    return { type: siteConstants.CHECK_SITEDOMAIN_SUCCESS, siteDomainProps };
  }
  function failure(error) {
    return { type: siteConstants.CHECK_SITEDOMAIN_FAILURE, error };
  }
}

function get_city_geoLocation(cityID) {
  return (dispatch) => {
    dispatch(request());
    siteService.get_city_geoLocation(cityID).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: siteConstants.GET_CITY_GEOLOCATION_REQUEST, data };
  }
  function success(data) {
    return { type: siteConstants.GET_CITY_GEOLOCATION_SUCCESS, data };
  }
  function failure(error) {
    return { type: siteConstants.GET_CITY_GEOLOCATION_FAILURE, error };
  }
}

function subDomain(formData, method, url) {
  return (dispatch) => {
    siteService.subDomain(formData, method, url).then(
      (responseData) => {
        dispatch(success(responseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConstants.SEND_SUBDOMAIN_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConstants.SEND_SUBDOMAIN_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConstants.SEND_SUBDOMAIN_FAILURE, error };
  }
}

function deleteDomain(childSiteID) {
  return (dispatch) => {
    siteService.deleteDomain(childSiteID).then(
      (responseData) => {
        dispatch(success(responseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConstants.SEND_SUBDOMAIN_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConstants.SEND_SUBDOMAIN_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConstants.SEND_SUBDOMAIN_FAILURE, error };
  }
}

function domainList(formData, method, url) {
  return (dispatch) => {
    siteService.subDomain(formData, method, url).then(
      (responseData) => {
        dispatch(success(responseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConstants.SEND_SUBDOMAINLIST_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConstants.SEND_SUBDOMAINLIST_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConstants.SEND_SUBDOMAINLIST_FAILURE, error };
  }
}

function installssl(formData, method, url) {
  return (dispatch) => {
    siteService.installssl(formData, method, url).then(
      (responseData) => {
        dispatch(success(responseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(responseData) {
    return { type: siteConstants.SEND_SSL_REQUEST, responseData };
  }
  function success(responseData) {
    return { type: siteConstants.SEND_SSL_SUCCESS, responseData };
  }
  function failure(error) {
    return { type: siteConstants.SEND_SSL_FAILURE, error };
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/actions/siteActions.js